<template>
<div class="chapter">
<div class="inner_page">
<p class="c3" id="calibre_pb_0"> <br class="calibre1"/></p>
<p class="c2"> <br class="calibre1"/></p>
<p class="c2"> <br class="calibre1"/></p>
<p class="c2">“The heavens roared as with thunder and from the
earth came the sound of moans. Storm clouds blackened the heavens
and the world was shrouded in the stillness of death. Lightning
cracked across the skies and flames flared up from the ground. From
the bloated clouds there came rain, and the rain washed all life
before it. When the flashes in the sky had died and the flames had
withered all that remained was as ash.”</p>
<p class="c2">—<i class="calibre3">Epic of Gilgamesh</i></p>
<p class="c2"> <br class="calibre1"/></p>
<p class="c2"> <br class="calibre1"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ.ch.fixed.fc.tidied.stylehacked.xfixed_split_001.vue?e69c6876